import React, { Fragment } from 'react'
import { DrilldownAttackEvent } from '../drilldown-content-view'
import {
  isNonMustacheOverview,
  AttackEventOverviewView
} from '../../../attack-event/attack-event-overview-view'
import { MustacheChapterView } from './mustache-chapter-view'

export function AttackEventOverview({
  organizationID,
  attackEvent: {
    application,
    httpRequest,
    userInput,
    details,
    server,
    result,
    sourceIP,
    id,
    ruleUuid,
    detectionType,
    callLocation,
    storyChapters,
    hidden
  }
}: {
  readonly organizationID: string
  readonly attackEvent: DrilldownAttackEvent
}) {
  if (
    isNonMustacheOverview({
      ruleUuid,
      detectionType
    })
  ) {
    return (
      <AttackEventOverviewView
        application={application}
        httpRequest={httpRequest}
        userInput={userInput}
        details={details}
        server={server}
        result={result}
        sourceIP={sourceIP}
        organizationID={organizationID}
        ruleUuid={ruleUuid}
        detectionType={detectionType}
        callLocation={callLocation}
      />
    )
  }
  return (
    <Fragment>
      {storyChapters.map((chapter, i) => (
        <MustacheChapterView
          key={i}
          organizationID={organizationID}
          eventId={id}
          hidden={hidden}
          ruleUuid={ruleUuid}
          chapter={chapter}
        />
      ))}
    </Fragment>
  )
}
